module.exports = __webpack_public_path__ + "components/resort-guide/static/icon-ski-lift--black-b135adb20bd5f963345855433a71f3a8.svg";